const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      background: theme.colors[4],
      color: theme.colors[1],
      paddingTop: (props) => props.headerHeight,
    },
    wrapper: {
      extend: theme.wrapper,
    },
    description: {
      marginTop: 75,
    },
    textWrapper: {
      marginTop: 180,
      marginBottom: 120,
      '& $text': {
        width: '100%',
        margin: '0 auto',
        columnCount: 2,
        columnGap: 80,
      },
    },
    text: {},
    gallery: {
      marginTop: 200,
      marginBottom: 200,
      '& .slick-list': {
        width: '80%',
        margin: '0 auto',
        borderRadius: 16,
        overflow: 'hidden',
      },
      '& .Carousel__carouselItem': {
        padding: 0,
      },
      '& .Carousel__carouselImg': {
        position: 'relative',
        zIndex: 1,
        paddingBottom: '54%',
        '& img': {
          width: '100%',
          height: '110%',
        },
      },
    },
    story: {
      extend: theme.wrapper,
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      flexWrap: 'nowrap',
      paddingBottom: 120,
      paddingTop: 120,
      background: theme.colors[1],
      color: theme.colors[5],
    },
    storyIntro: {
      flex: '0 0 280px',
      marginBottom: 50,
      '& .blockTitle__title': {
        fontSize: 35,
        lineHeight: 1.2,
        fontWeight: 400,
        '& > p > div': {
          marginTop: '-0.3em',
        },
      },
    },
    storyList: {
      flex: '1 1 auto',
      paddingLeft: 120,
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    storyItem: {
      marginBottom: 80,
      '&:nth-child(6n+1)': {
        marginBottom: '-50px',
      },
      '&:nth-child(2n+2)': {
        '& $storyItemTitle': {
          WebkitTextFillColor: 'transparent',
          TextFillColor: 'transparent',
          MozTextStrokeColor: theme.colors[3],
          WebkitTextStrokeColor: theme.colors[3],
          MozTextStrokeWidth: theme.detect.ieEdgeIE ? '1px' : '0.008em',
          WebkitTextStrokeWidth: theme.detect.ieEdgeIE ? '1px' : '0.008em',
          WebkitFontSmoothing: 'antialiased',
        },
      },
      '&:nth-child(6n+2)': {
        flex: '0 0 100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      },
      '&:nth-child(3n+3)': {
        flex: '0 0 100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    storyItemTitle: {
      extend: theme.typography.h1,
      color: theme.colors[3],
      fontFamily: theme.fonts[0],
      fontSize: 150,
      marginBottom: 0,
      textIndent: '-0.04em',
    },
    storyItemImg: {
      width: '15vw',
      margin: '0 auto 56px',
      '& .square': {
        borderRadius: '100%',
        background: theme.colors[3],
        extend: theme.sizingRatio,
        overflow: 'hidden',
        '& .container': {
          width: '70%',
          height: '70%',
          margin: '15%',
          backgroundSize: 'cover',
        },
      },
    },
    storyItemText: {
      maxWidth: 320,
      fontSize: 15,
      fontFamily: theme.fonts[0],
      lineHeight: '1.2',
      marginTop: '0.5em',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    textWrapper: {
      marginTop: 60,
    },
    storyItem: {
      marginBottom: 80,
      '&:nth-child(6n+1)': {
        marginBottom: 80,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    textWrapper: {
      '& $text': {
        columnCount: 1,
        columnGap: 0,
      },
    },
    text: {},

    gallery: {
      marginTop: 50,
      marginBottom: 50,
      '& .slick-list': {
        width: '100%',
      },
      '& .slick-arrow': {
        display: 'none',
      },
      '& .slick-dots': {
        bottom: -20,
      },
    },

    story: {
      paddingBottom: 60,
      paddingTop: 60,
      display: 'block',
      marginBottom: 50,
      '& .blockTitle__title': {
        fontSize: 20,
      },
    },
    storyList: {
      display: 'block',
      paddingLeft: 0,
    },
    storyItem: {
      display: 'block!important',
      marginTop: '0!important',
      marginBottom: 40,
      '&:nth-child(6n+1)': {
        marginBottom: 40,
      },
    },
    storyItemImg: {
      width: '45vw',
      margin: '0 auto 26px',
    },
    storyItemTitle: {
      WebkitTextFillColor: `${theme.colors[3]}!important`,
      TextFillColor: `${theme.colors[3]}!important`,
      MozTextStrokeColor: 'transparent!important',
      WebkitTextStrokeColor: 'transparent!important',
      MozTextStrokeWidth: '0',
      WebkitTextStrokeWidth: '0',
      WebkitFontSmoothing: 'antialiased',
      color: theme.colors[3],
    },
  }

  return output
}

export default style
